import BaseImportModal from "@/components/reusables/BaseImportModal";
import React from "react";
import { useStartImportMutation } from "@redux/features/importApi";
import { toastError } from "@helpers/utils";
import { useGetImportableColumnsQuery } from "@redux/features/dfs/dfsApi";

interface CustomerImportModalProperties {
    isOpen?: boolean;
    onClose?: () => void;
}

export default function CustomerImportModal(props: CustomerImportModalProperties) {
    const [importCustomers, { isLoading: isImportLoading }] = useStartImportMutation();

    const { data: columns = [], isLoading: isColumnsLoading } = useGetImportableColumnsQuery({ module: "customer" });

    return (
        <BaseImportModal
            optionsList={columns}
            isOpen={props.isOpen}
            onClose={props.onClose}
            isLoading={isImportLoading || isColumnsLoading}
            onImport={(formData) => {
                importCustomers({ module: "customer", formData }).unwrap()
                    .then(() => {
                        props.onClose?.();
                    })
                    .catch((e) => {
                        console.error(e);
                        toastError(e);
                    });
            }}
        />
    );
}
